import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, MessageCircle, Mail, Check } from "lucide-react";
import { api, errText } from "../../lib/admin";

const tomorrow = () => { const d = new Date(); d.setDate(d.getDate() + 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

const waText = (a) => {
  const when = a.confirmed_time ? `alle ${a.confirmed_time}` : a.preferred_time ? `(${a.preferred_time.toLowerCase()})` : "";
  return `Ciao ${a.name.split(" ")[0]}, ti ricordiamo il tuo appuntamento di domani ${when} da Gioia Centro Estetico per ${a.service}. Ti aspettiamo in Via Tre Fontane 37! Se hai un imprevisto, scrivici qui.`.replace("  ", " ");
};

const waHref = (a) => {
  let d = (a.phone || "").replace(/\D/g, "");
  if (d.length === 10) d = `39${d}`;
  return `https://wa.me/${d}?text=${encodeURIComponent(waText(a))}`;
};

export const RemindersPanel = () => {
  const [items, setItems] = useState(null);
  const [auto, setAuto] = useState(false);
  useEffect(() => {
    api.get("/admin/status").then((r) => setAuto(!!r.data?.whatsapp_auto)).catch(() => {});
  }, []);
  useEffect(() => {
    const t = tomorrow();
    api.get("/admin/appointments")
      .then((r) => setItems((Array.isArray(r.data) ? r.data : []).filter((a) => a.status === "confirmed" && a.preferred_date === t)
        .sort((x, y) => (x.confirmed_time || "99").localeCompare(y.confirmed_time || "99"))))
      .catch((e) => { toast.error(errText(e)); setItems([]); });
  }, []);
  const markSent = (a) => {
    setItems((xs) => xs.map((x) => (x.id === a.id ? { ...x, reminder_wa_sent: true } : x)));
    api.patch(`/admin/appointments/${a.id}`, { reminder_wa_sent: true }).catch(() => {});
  };
  if (!items) return null;
  return (
    <section className="bg-[#14110F] text-[#F6F2EC] rounded-2xl p-6" data-testid="reminders-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-[0.7rem] tracking-[0.18em] uppercase text-[#C9A66B]"><BellRing className="w-4 h-4" /> Promemoria di domani</p>
        <p className="text-xs text-[#c9bfb2]" data-testid="reminders-mode">{auto ? "Email e WhatsApp partono da soli alle 10:00" : "L'email parte da sola alle 10:00 a chi l'ha lasciata · WhatsApp con un tocco"}</p>
      </div>
      {items.length === 0 ? <p className="mt-4 text-[#d9d0c4]" data-testid="reminders-empty">Nessun appuntamento confermato per domani.</p> : (
        <ul className="mt-4 divide-y divide-[#F6F2EC]/10">
          {items.map((a) => (
            <li key={a.id} className="py-3 flex flex-wrap items-center gap-3" data-testid={`reminder-row-${a.id}`}>
              <span className="font-stencil tracking-[0.12em] text-[#C9A66B] w-14">{a.confirmed_time || "—"}</span>
              <span className="min-w-0 flex-1">
                <span className="block text-[#F6F2EC]">{a.name}</span>
                <span className="block text-xs text-[#c9bfb2]">{a.service}</span>
              </span>
              <span className={`inline-flex items-center gap-1 text-xs ${a.reminder_email_sent_at ? "text-[#a8d5b1]" : "text-[#8b8278]"}`} data-testid={`reminder-email-status-${a.id}`}>
                <Mail className="w-3.5 h-3.5" /> {a.reminder_email_sent_at ? "Email inviata" : a.email ? "Email alle 10:00" : "Nessuna email"}
              </span>
              <a href={waHref(a)} target="_blank" rel="noreferrer" onClick={() => markSent(a)} data-testid={`reminder-wa-${a.id}`}
                className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-[0.7rem] tracking-[0.14em] uppercase transition-colors duration-200 ${a.reminder_wa_sent ? "border border-[#a8d5b1]/50 text-[#a8d5b1]" : "bg-[#C9A66B] text-[#14110F] hover:bg-[#F6F2EC]"}`}>
                {a.reminder_wa_sent ? <Check className="w-4 h-4" /> : <MessageCircle className="w-4 h-4" />} {a.reminder_wa_auto_at ? "WhatsApp automatico inviato" : a.reminder_wa_sent ? "WhatsApp inviato" : "Invia WhatsApp"}
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
